var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TitleWrapper',{staticClass:"title",attrs:{"bgcolor":_vm.Color}},[_c('div',{staticClass:"title-wrapper",class:_vm.TitleClass || 'default-title'},[_c('h4',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.TitleCopy)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }